import styled from 'styled-components'
import { ResponsiveImage } from '../ResponsiveImage/ResponsiveImage'

export const Link = styled.a`
  width: 25rem;
`

export const Image = styled(ResponsiveImage)`
  display: flex;
  object-fit: cover;
  margin-bottom: 1.7rem;
  height: 16.5rem;
`
